// extracted by mini-css-extract-plugin
export var borderRadius = "_et-4";
export var large = "_et-3";
export var logoContainer = "_et-0";
export var nameLogo = "_et-2";
export var small = "_et-1";